// Shared resolver for notification action_url → in-app path.
//
// Convention:
//   - Backend SHOULD emit bare paths like '/sites/<id>' or '/uploads';
//     this util prepends the recipient's role prefix.
//   - If the backend already wrote a role prefix (e.g. '/vendor/...'),
//     don't double-prepend.
//   - If the backend mistakenly wrote the WRONG role prefix
//     (e.g. '/client/sites/...' on a vendor notification — happens in
//     seeded data and older endpoints), strip it before prepending the
//     correct one.  Otherwise the result is '/vendor/client/sites/<id>'
//     → 404.
//   - '/admin/...' paths are Django admin, not React routes — caller
//     should full-page redirect.

const ROLE_PREFIXES = ['/vendor/', '/client/', '/admin/'];

export type NotificationNav =
  | { kind: 'external'; href: string }
  | { kind: 'spa'; path: string }
  | { kind: 'noop' };

export function resolveNotificationNav(
  actionUrl: string | null | undefined,
  role: string | undefined,
): NotificationNav {
  if (!actionUrl || !role) return { kind: 'noop' };

  if (actionUrl.startsWith('/admin/')) {
    return { kind: 'external', href: actionUrl };
  }

  const rolePrefix = `/${role}`;

  if (actionUrl === rolePrefix || actionUrl.startsWith(rolePrefix + '/')) {
    return { kind: 'spa', path: actionUrl };
  }

  let cleaned = actionUrl;
  for (const p of ROLE_PREFIXES) {
    if (cleaned.startsWith(p)) {
      cleaned = cleaned.slice(p.length - 1);
      break;
    }
  }
  return { kind: 'spa', path: `${rolePrefix}${cleaned}` };
}
